import * as types from "../actions/types";



const initialState = {
  applicantQuestionSetList: []
};


export default function applicantQuestionSet(state = initialState, action) {
  switch (action.type) {
    case types.GET_APPLICANT_QUESTION_SET:
      return {
        ...state,
        applicantQuestionSetList: action.payload,
      };
    case types.GET_APPLICANT_QUESTION_SET_BY_ID:
      return {
        ...state,
        variant: action.payload,
      };
    case types.GET_APPLICANT_QUESTION_MODAL:
      return {
        ...state,
        questionsModal: action.payload,
      };
    case types.GET_APPLICANT_QUESTION_MODAL_ADD:
      return {
        ...state,
        qustionsModalAdd: action.payload,
      };

    default:
      return state;
  }
}